import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import { tr } from '../til';

// Manguberdi ilovasining versiyalari. Admin yangi APK'ni shu yerga
// yuklaydi, ilova esa uni serverdan o'zi topib yangilanadi. "Majburiy"
// belgilansa, undan eski ilova ishlamay qo'yadi va yangilashni talab qiladi.

const card = {
  background: '#fff',
  borderRadius: '12px',
  padding: '24px',
  boxShadow: '0 1px 8px rgba(0,0,0,0.06)',
  marginBottom: '24px'
};

const inputStyle = {
  padding: '10px 12px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '14px',
  width: '100%',
  boxSizing: 'border-box'
};

const smallBtn = {
  padding: '6px 12px',
  background: '#eef1f7',
  color: '#1a1a2e',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '12px',
  cursor: 'pointer',
  whiteSpace: 'nowrap'
};

const ABILAR = [
  { kod: 'universal', nom: tr("Universal — barcha telefonlar") },
  { kod: 'arm64-v8a', nom: tr("arm64-v8a — zamonaviy telefonlar") },
  { kod: 'armeabi-v7a', nom: tr("armeabi-v7a — eski 32 bitli telefonlar") },
  { kod: 'x86_64', nom: 'x86_64' }
];

const mb = (bayt) => `${(Number(bayt) / 1024 / 1024).toFixed(1)} MB`;

// Ikki ilova: xodimlar (Manguberdi) va mahkumlar (prob24). Ikkalasi ham
// Play Market'da emas — APK shu yerdan tarqaladi va ilova o'zi yangilanadi.
const ILOVALAR = [
  { kod: 'manguberdi', nom: tr("Manguberdi (xodimlar)"),
    izoh: tr("Manguberdi ilovasining yangi APK faylini shu yerga yuklang — xodimlarning ilovasi uni o'zi topadi. Fayl faqat tizimga kirgan xodimga beriladi.") },
  { kod: 'prob24', nom: tr("prob24 (mahkumlar)"),
    izoh: tr("prob24 ning yangi APK faylini shu yerga yuklang — mahkum ilovasi uni o'zi topadi. Fayl faqat biriktirilgan qurilmaga beriladi. Majburiy versiya ham signal yuborishni to'xtatmaydi — ilova mahkumdan yangilashni so'rab turadi.") }
];

const bosh = () => ({ fayl: null, versiya: '', build: '', abi: 'universal', majburiy: false, izoh: '' });

// Majburiy versiyada har qanday telefon uchun fayl bo'lishi kerak —
// aks holda mos fayli yo'q telefon ilovadan butunlay qolib ketadi.
//
// Universal APK bitta o'zi yetadi: uning versionCode'i 3000 + build
// qilib yig'iladi, ya'ni split (1000/2000 + build) o'rnatmalar ustiga
// ham tushadi. Shuning uchun `splitBor` endi hisobga olinmaydi.
const hammagaYetadimi = (fayllar) => {
  const abilar = new Set(fayllar.filter(f => f.is_active).map(f => f.abi));
  return abilar.has('universal')
    || (abilar.has('arm64-v8a') && abilar.has('armeabi-v7a'));
};

function IlovaVersiyalari() {
  const [ilova, setIlova] = useState('manguberdi');
  const [malumot, setMalumot] = useState(null);
  const [form, setForm] = useState(bosh());
  const [faylKaliti, setFaylKaliti] = useState(0);
  const [foiz, setFoiz] = useState(null);
  const [xato, setXato] = useState('');
  const [xabar, setXabar] = useState('');

  const token = localStorage.getItem('token');

  const yukla = useCallback(() => {
    axios.get(`${API}/ilova/versiyalar`, { headers: { authorization: token }, params: { ilova } })
      .then(r => setMalumot(r.data))
      .catch(err => setXato(err.response?.data?.error || tr("Ro'yxatni ochib bo'lmadi.")));
  }, [token, ilova]);

  const ilovaniTanla = (kod) => {
    setIlova(kod);
    setMalumot(null);
    setForm(bosh());
    setFaylKaliti(k => k + 1);
    setXato(''); setXabar('');
  };

  const joriy = ILOVALAR.find(i => i.kod === ilova);

  useEffect(() => { yukla(); }, [yukla]);

  const set = (k, v) => setForm({ ...form, [k]: v });

  // "manguberdi-1.4.0+14.apk" kabi nomdan versiya va build'ni taklif qiladi.
  const faylTanlandi = (fayl) => {
    const m = fayl?.name.match(/(\d+\.\d+\.\d+)[+_-](\d{1,3})\b/);
    const abi = ABILAR.find(a => a.kod !== 'universal' && fayl?.name.includes(a.kod));
    setForm({
      ...form,
      fayl,
      versiya: form.versiya || (m ? m[1] : ''),
      build: form.build || (m ? m[2] : ''),
      abi: abi ? abi.kod : form.abi
    });
  };

  const yuborish = async () => {
    setXato(''); setXabar('');
    if (!form.fayl) { setXato(tr("APK faylni tanlang")); return; }
    if (!/^\d+\.\d+\.\d+$/.test(form.versiya.trim())) { setXato(tr("Versiya 1.4.0 ko'rinishida bo'lsin")); return; }
    if (form.majburiy && !window.confirm(tr(
      "Majburiy versiya: undan eski ilovalar ishlamay qoladi va xodimlar yangilashga majbur bo'ladi. Davom etilsinmi?"
    ))) return;

    const fd = new FormData();
    fd.append('ilova', ilova);
    fd.append('versiya', form.versiya.trim());
    fd.append('build', form.build);
    fd.append('abi', form.abi);
    fd.append('majburiy', String(form.majburiy));
    fd.append('izoh', form.izoh.trim());
    fd.append('fayl', form.fayl);

    setFoiz(0);
    try {
      await axios.post(`${API}/ilova/versiyalar`, fd, {
        headers: { authorization: token },
        onUploadProgress: (e) => e.total && setFoiz(Math.round((e.loaded / e.total) * 100))
      });
      setXabar(tr("{versiya} ({abi}) yuklandi.", { versiya: form.versiya, abi: form.abi }));
      setForm(bosh());
      setFaylKaliti(k => k + 1);
      yukla();
    } catch (err) {
      setXato(err.response?.data?.error || tr("Fayl yuklanmadi. Qaytadan urinib ko'ring."));
    } finally {
      setFoiz(null);
    }
  };

  const ozgartir = async (v, maydonlar, savol) => {
    if (savol && !window.confirm(savol)) return;
    setXato(''); setXabar('');
    try {
      await axios.put(`${API}/ilova/versiyalar/${v.id}`, maydonlar, { headers: { authorization: token } });
      yukla();
    } catch (err) {
      setXato(err.response?.data?.error || tr("Amal bajarilmadi."));
    }
  };


  // Bir build'ning fayllari birga ko'rsatiladi.
  const guruhlar = [];
  for (const v of malumot?.versiyalar || []) {
    const g = guruhlar.find(x => x.build === v.build);
    if (g) g.fayllar.push(v);
    else guruhlar.push({ build: v.build, versiya: v.versiya, majburiy: v.majburiy, izoh: v.izoh, fayllar: [v] });
  }

  return (
    <div>
      <h2 style={{ marginBottom: '12px', fontSize: '22px' }}>📲 {tr("Ilova versiyalari")}</h2>
      <div role="tablist" aria-label={tr("Ilova")} style={{ display: 'flex', gap: '8px', marginBottom: '12px', flexWrap: 'wrap' }}>
        {ILOVALAR.map(i => (
          <button
            key={i.kod}
            role="tab"
            aria-selected={ilova === i.kod}
            onClick={() => ilovaniTanla(i.kod)}
            style={{
              ...smallBtn, padding: '8px 16px', fontSize: '14px',
              background: ilova === i.kod ? '#1a1a2e' : '#eef1f7',
              color: ilova === i.kod ? '#fff' : '#1a1a2e'
            }}
          >
            {i.nom}
          </button>
        ))}
      </div>
      <p style={{ marginTop: 0, marginBottom: '20px', color: '#888', fontSize: '13px' }}>
        {joriy.izoh}
      </p>

      {malumot && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '12px', marginBottom: '20px' }}>
          <div style={{ ...card, padding: '18px', marginBottom: 0 }}>
            <div style={{ color: '#888', fontSize: '13px', marginBottom: '6px' }}>{tr("Oxirgi build")}</div>
            <div style={{ fontSize: '26px', fontWeight: '600' }}>{malumot.oxirgi_build ?? '—'}</div>
          </div>
          <div style={{ ...card, padding: '18px', marginBottom: 0 }}>
            <div style={{ color: '#888', fontSize: '13px', marginBottom: '6px' }}>{tr("Eng kam ruxsat etilgan build")}</div>
            <div style={{ fontSize: '26px', fontWeight: '600', color: malumot.eng_kam_build ? '#c93636' : '#1a1a2e' }}>
              {malumot.eng_kam_build || '—'}
            </div>
            <div style={{ color: '#999', fontSize: '12px' }}>{tr("Undan eskisi ishlamaydi")}</div>
          </div>
        </div>
      )}

      <div style={card}>
        <h3 style={{ marginTop: 0, marginBottom: '14px', fontSize: '16px' }}>{tr("Yangi versiya yuklash")}</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
          <div style={{ gridColumn: '1 / -1' }}>
            <input
              key={faylKaliti}
              type="file"
              accept=".apk,application/vnd.android.package-archive"
              aria-label={tr("APK fayl")}
              onChange={e => faylTanlandi(e.target.files[0] || null)}
              style={inputStyle}
            />
            {form.fayl && <div style={{ color: '#888', fontSize: '12px', marginTop: '4px' }}>{mb(form.fayl.size)}</div>}
          </div>
          <input type="text" placeholder={tr("Versiya, masalan 1.4.0")} value={form.versiya}
            onChange={e => set('versiya', e.target.value)} style={inputStyle} />
          <input type="number" min="1" max="999" placeholder={tr("Build raqami, masalan 14")} value={form.build}
            onChange={e => set('build', e.target.value)} style={inputStyle} />
          <select value={form.abi} onChange={e => set('abi', e.target.value)} style={inputStyle}
            aria-label={tr("Protsessor turi")}>
            {ABILAR.map(a => <option key={a.kod} value={a.kod}>{a.nom}</option>)}
          </select>
          {form.abi === 'universal' && (
            <div style={{ gridColumn: '1 / -1', background: '#eef5ff', color: '#1a5fb4', padding: '8px 12px', borderRadius: '8px', fontSize: '12px' }}>
              {tr("Universal fayl mavjud o'rnatmalar ustiga tushishi uchun u \"--build-number=3000+build\" bilan yig'ilgan bo'lishi kerak (masalan build 35 uchun 3035). Bu yerga esa oddiy raqam — 35 — yoziladi.")}
            </div>
          )}
          <textarea rows={3} placeholder={tr("Nima yangilik (xodimlarga ko'rsatiladi)")} value={form.izoh}
            onChange={e => set('izoh', e.target.value)}
            style={{ ...inputStyle, gridColumn: '1 / -1', resize: 'vertical', fontFamily: 'inherit' }} />
          <label style={{ gridColumn: '1 / -1', display: 'flex', gap: '8px', alignItems: 'flex-start', fontSize: '14px', cursor: 'pointer' }}>
            <input type="checkbox" checked={form.majburiy} onChange={e => set('majburiy', e.target.checked)}
              style={{ marginTop: '3px' }} />
            <span>
              {tr("Majburiy yangilash")}
              <span style={{ display: 'block', color: '#888', fontSize: '12px' }}>
                {tr("Xavfsizlik tuzatishi yoki server o'zgarishi bo'lsa belgilang. Undan eski ilova hech narsa ochmaydi — faqat yangilash oynasi chiqadi.")}
              </span>
            </span>
          </label>
        </div>

        <p style={{ color: '#888', fontSize: '12px', lineHeight: 1.6 }}>
          {tr("Versiya va build pubspec.yaml dagi \"version: 1.4.0+14\" qatoridan olinadi: 1.4.0 — versiya, 14 — build. Har yangi versiyada build kattalashishi shart.")}
          <br />
          {tr("Odatda bitta universal fayl yetarli — u barcha telefonlarga tushadi. Protsessor bo'yicha alohida fayllar faqat yuklab olish hajmini kichraytirish kerak bo'lganda yuklanadi; ularni bir xil versiya va build bilan yuboring.")}
        </p>

        {xato && <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginBottom: '12px' }}>{xato}</div>}
        {xabar && <div style={{ background: '#e9f9ed', color: '#2d8a2d', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginBottom: '12px' }}>{xabar}</div>}

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'flex-end' }}>
          {foiz !== null && (
            <div style={{ flex: 1, height: '8px', background: '#f0f0f5', borderRadius: '4px', overflow: 'hidden' }}
              role="progressbar" aria-valuenow={foiz} aria-valuemin={0} aria-valuemax={100}>
              <div style={{ width: `${foiz}%`, height: '100%', background: '#4f8ef7' }} />
            </div>
          )}
          <button
            onClick={yuborish}
            disabled={foiz !== null}
            style={{
              padding: '10px 24px', background: foiz !== null ? '#888' : '#1a1a2e', color: '#fff',
              border: 'none', borderRadius: '8px', fontSize: '14px', cursor: foiz !== null ? 'default' : 'pointer'
            }}
          >
            {foiz !== null ? tr("Yuklanmoqda... {foiz}%", { foiz }) : tr("Yuklash")}
          </button>
        </div>
      </div>

      <div style={card}>
        <h3 style={{ marginTop: 0, marginBottom: '14px', fontSize: '16px' }}>{tr("Yuklangan versiyalar")}</h3>
        {guruhlar.length === 0 && <p style={{ color: '#999', fontSize: '14px', margin: 0 }}>{tr("Hali versiya yuklanmagan")}</p>}

        {guruhlar.map(g => (
          <div key={g.build} style={{ borderTop: '1px solid #f0f0f5', padding: '14px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
              <div>
                <b style={{ fontSize: '16px' }}>{g.versiya}</b>
                <span style={{ color: '#888' }}> · build {g.build}</span>
                {g.majburiy && (
                  <span style={{ marginLeft: '8px', background: '#ffeaea', color: '#c93636', padding: '2px 10px', borderRadius: '20px', fontSize: '12px' }}>
                    {tr("majburiy")}
                  </span>
                )}
              </div>
              <button
                onClick={() => ozgartir(g.fayllar[0], { majburiy: !g.majburiy },
                  g.majburiy ? null : tr("Majburiy versiya: undan eski ilovalar ishlamay qoladi va xodimlar yangilashga majbur bo'ladi. Davom etilsinmi?"))}
                style={{ ...smallBtn, color: g.majburiy ? '#1a1a2e' : '#c93636' }}
              >
                {g.majburiy ? tr("Majburiylikni olib tashlash") : tr("Majburiy qilish")}
              </button>
            </div>
            {g.izoh && <div style={{ color: '#555', fontSize: '13px', marginTop: '6px', whiteSpace: 'pre-wrap' }}>{g.izoh}</div>}
            {g.majburiy && !hammagaYetadimi(g.fayllar) && (
              <div style={{ background: '#fff8e6', color: '#8a6d2d', padding: '8px 12px', borderRadius: '8px', fontSize: '12px', marginTop: '8px' }}>
                {tr("Diqqat: bu majburiy versiyada barcha telefonlar uchun fayl yo'q. Universal faylni yuklang — aks holda ba'zi xodimlar ilovani yangilay olmaydi.")}
              </div>
            )}
            <div style={{ overflowX: 'auto', marginTop: '8px' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', minWidth: '560px' }}>
                <tbody>
                  {g.fayllar.map(f => (
                    <tr key={f.id} style={{ opacity: f.is_active ? 1 : 0.45 }}>
                      <td style={{ padding: '6px 8px' }}>{f.abi}</td>
                      <td style={{ padding: '6px 8px', color: '#666' }}>{mb(f.hajm)}</td>
                      <td style={{ padding: '6px 8px', color: '#666' }}>{new Date(f.created_at).toLocaleString('uz-UZ')}</td>
                      <td style={{ padding: '6px 8px', color: '#888' }}>{f.yuklagan_nomi || '—'}</td>
                      <td style={{ padding: '6px 8px', color: '#aaa', fontFamily: 'monospace' }} title={f.sha256}>
                        {f.sha256.slice(0, 12)}…
                      </td>
                      <td style={{ padding: '6px 8px', textAlign: 'right' }}>
                        <button
                          onClick={() => ozgartir(f, { is_active: !f.is_active },
                            f.is_active ? tr("Bu fayl qaytarib olinsinmi? Xodimlarga boshqa taklif qilinmaydi.") : null)}
                          style={smallBtn}
                        >
                          {f.is_active ? tr("Qaytarib olish") : tr("Qayta faollashtirish")}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default IlovaVersiyalari;
